import { Link } from "react-router";
import type { NotificationTypeConfig } from "@/features/notifications/types/notifications.type";

type NotificationItemProps = {
  config: NotificationTypeConfig
  count: number
};

export const NotificationItem = ({ config, count }: NotificationItemProps) => {
  return (
    <li>
      <Link
        to={config.route}
        className="flex items-center justify-between py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
      >
        <span>{config.label}</span>
        <span className="ml-auto flex items-center justify-center min-w-[20px] h-5 px-2 text-xs font-semibold text-white bg-primary rounded-full">
          {count}
        </span>
      </Link>
    </li>
  );
};
